import one from "../assets/svg/projects/one.svg";
import two from "../assets/svg/projects/two.svg";
import three from "../assets/svg/projects/three.svg";
import four from "../assets/svg/projects/four.svg";
import five from "../assets/svg/projects/five.svg";
import six from "../assets/svg/projects/six.svg";
import seven from "../assets/svg/projects/seven.svg";
import eight from "../assets/svg/projects/eight.svg";

export const projectsData = [
  {
    id: 1,
    projectName: "Mounty",
    projectDesc: "Ëxplore outdoor and Adventure travel app",
    tags: ["kotlin", "kmm", "Material Ui"],
    code: "https://play.google.com/store/apps/details?id=com.mounty.camper",
    demo: "https://play.google.com/store/apps/details?id=com.mounty.camper",
    image: one,
  },
  {
    id: 2,
    projectName: "Partner Mounty",
    projectDesc: "Manage your Travel Offerings",
    tags: ["kotlin", "kmm", "Material Ui"],
    code: "https://play.google.com/store/apps/details?id=com.mounty.partner",
    demo: "https://play.google.com/store/apps/details?id=com.mounty.partner",
    image: two,
  },
  {
    id: 3,
    projectName: "Video Player App",
    projectDesc:
      "you can also watch a plethora of Free Movies in all languages from your Local.",
    tags: ["kotlin", "Streaming", "Material Ui"],
    code: "https://play.google.com/store/apps/details?id=com.mdplayer.mdplayer",
    demo: "https://play.google.com/store/apps/details?id=com.mdplayer.mdplayer",
    image: three,
  },
  {
    id: 4,
    projectName: "International Schooling",
    projectDesc: "Online learning APP.",
    tags: ["kotlin", "Firebase"],
    code: "https://play.google.com/store/apps/details?id=org.internationalschooling.user",
    demo: "https://play.google.com/store/apps/details?id=org.internationalschooling.user",
    image: four,
  },
  //   {
  //     id: 5,
  //     projectName: "Car Pooling System",
  //     projectDesc: "",
  //     tags: ["Flutter", "React"],
  //     code: "",
  //     demo: "",
  //     image: "",
  //   },
  //   {
  //     id: 6,
  //     projectName: "Car Pooling System",
  //     projectDesc: "",
  //     tags: ["Flutter", "React"],
  //     code: "",
  //     demo: "",
  //     image: "",
  //   },
  //   {
  //     id: 7,
  //     projectName: "Car Pooling System",
  //     projectDesc: "",
  //     tags: ["Flutter", "React"],
  //     code: "",
  //     demo: "",
  //     image: "",
  //   },
  //   {
  //     id: 8,
  //     projectName: "Car Pooling System",
  //     projectDesc: "",
  //     tags: ["Flutter", "React"],
  //     code: "",
  //     demo: "",
  //     image: "",
  //   },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
